





















import { Vue, Component } from "vue-property-decorator";
import { uid } from "@szgc/plt-core-v2";
import { ntko_addon } from "./index";
import { Loading } from "element-ui";
@Component({
  name: "NtkoSign"
})
export default class NtkoSign extends Vue {
  visible: boolean = false;
  id: string = "r" + uid();
  docViewerHelper!: any;

  oldSignList: any[] = [];
  newSignList: any[] = [];

  loading!: any;

  options: App.Ntko.NtkoPdfH5SignOptions = {
    fileUrl: "",
    fileName: "",
    token: "",
    jwtKey: "",
    account: "",
    password: "",
    uploadUrl: location.origin + "/api/appproc/ruanhang/file/upload"
  };

  signed: boolean = false;

  get title() {
    return `签章 -【${this.options.fileName}】`;
  }

  get upload_url() {
    return this.options.uploadUrl || location.origin + "/api/appproc/ruanhang/file/upload";
  }

  onSignOpened() {
    if (!document.newDocumentSdk) {
      this.$alert("签章控件未正确安装", "提示", {
        confirmButtonText: "确定",
        type: "error",
        callback: () => {
          this.visible = false;
        }
      });
    }

    this.docViewerHelper = document.newDocumentSdk();

    const embedReaderPrams: Record<string, unknown> = {
      viewMode: "DigitalSign",
      signMode: ntko_addon.signMode || "Server"
    };
    if (ntko_addon.authorizeCallback) {
      embedReaderPrams.authorizeCallback = ntko_addon.authorizeCallback;
    }
    if (ntko_addon.unauthorizeCallback) {
      embedReaderPrams.unauthorizeCallback = ntko_addon.unauthorizeCallback;
    }

    this.docViewerHelper.embedReader(this.id, ntko_addon.reader_iframe_url, embedReaderPrams);
    this.docViewerHelper.setReaderEventListener((event: any, payload: any) => {
      console.log("阅读器事件:", event, payload);
    });

    this.docViewerHelper.addSignServerAuthCallback(async (credentials: any) => {
      if (typeof credentials.error === "string") {
        // 登录失败
        console.log("addSignServerAuthCallback 1", credentials.error);
      } else if (typeof credentials.canDoSign === "boolean" && !credentials.canDoSign) {
        console.log("addSignServerAuthCallback 2", "你没有签章权限");
      } else if (typeof credentials.signOut === "boolean" && !!credentials.signOut) {
        console.log("addSignServerAuthCallback 3", "登出成功");

        const account = this.options.account || "",
          password = this.options.password || "";

        console.log("尝试使用账号密码登录", account, password);
        // 尝试登录印章服务器
        this.docViewerHelper.loginSignServer(
          // 印章服务器URL
          ntko_addon.h5_svr_url,
          // 用户名
          account,
          // 登录密码
          password
        );
      } else {
        console.log(
          "addSignServerAuthCallback 4",
          "登录成功:" + (credentials.realName || credentials.userName)
        );
      }
    });

    this.docViewerHelper.addDocumentOpenedCallback((status: any, error: any) => {
      if ("ok" === status) {
        // 设置默认印章密码
        // 盖章时不再弹窗密码框
        this.docViewerHelper.setDefaultSealPassword("111111");

        // 设置默认证书密码
        this.docViewerHelper.setDefaultKeystorePassword("111111");

        // 退出
        this.docViewerHelper.signOutSignServer();

        // 尝试登录印章服务器
        // this.docViewerHelper.loginSignServer(
        //   // 印章服务器URL
        //   ntko_addon.h5_svr_url,
        //   // 用户名
        //   "zhangsan",
        //   // 登录密码
        //   "111111"
        // );

        this.signed = false;
      } else if ("error" === status) {
        alert("打开文档失败");
      } else {
        if ("download-failed" === status) {
          console.warn("下载文档失败", error);
        } else if ("invalid-file-type" === status) {
          console.warn("不支持的文件格式");
        } else {
          console.warn(error || "打开文档失败");
        }

        this.docViewerHelper.closeDocument();
      }
    });

    /**
     * 阅读器加载完成事件
     */
    this.docViewerHelper.addReaderReadyCallback(() => {
      console.log("this.docViewerHelper.addReaderReadyCallback");

      this.docViewerHelper.setSignServer(ntko_addon.h5_svr_url);
      // 在文档打开后设定用户信息
      // 接受两种格式的参数，当为字符类型时，设置用户名；为对象类型时设置JSON格式的用户详细信息
      // docViewerHelper.setSessionUser('测试用户513');
      // this.docViewerHelper.setSessionUser({
      //   userName: "zhangsan",
      //   userId: "123456"
      // });

      const file_url = new URL(this.options.fileUrl);
      file_url.searchParams.append(this.options.jwtKey, this.options.token);
      const file_name = this.options.fileName;

      console.log("file_url", file_url.toString());

      const fileOptions = {
        fileName: file_name,
        fileUrl: file_url.toString(),
        readOnly: false
      };

      this.docViewerHelper.openPdfDocument(fileOptions, (e: any) => {
        console.log("OpenEvent", e);
        if (e.error) {
          alert("打开文档失败: " + e.error);
          return;
        }

        if (e.status !== "ok") {
          // 打开文档失败
        } else {
          //打开文档成功
          this.docViewerHelper.listDigitalSignatures();
        }
      });
    });

    this.docViewerHelper.addDigitalSignatureRetrieveCallback((value: any) => {
      if (typeof value === "object" && typeof value.length === "number") {
        if (value.length > 0) {
          this.oldSignList = JSON.parse(JSON.stringify(value));
        }
      }
    });

    this.docViewerHelper.onDigitalSignaturesParsed = (event: any) => {
      this.newSignList = JSON.parse(JSON.stringify(event.payload.signatures));
    };

    this.docViewerHelper.onFileUploadComplete = (event: any) => {
      this.loading && this.loading.close();
      const payload = event.payload;
      if (payload.error) {
        this.$alert("保存签章失败", "提示", {
          confirmButtonText: "确定",
          type: "error"
        });
      } else {
        const resp = JSON.parse(payload.response);
        if (!resp.success) {
          this.$alert("保存签章失败", "提示", {
            confirmButtonText: "确定",
            type: "error"
          });
        } else {
          this.$alert("保存签章成功", "提示", {
            confirmButtonText: "确定",
            type: "success",
            callback: () => {
              this.$emit("signed", resp.data);
              this.visible = false;
            }
          });
        }
      }
    };

    /**
     * 签章回调事件
     */
    this.docViewerHelper.onDocumentSignedWithResult = (event: any) => {
      if (event.payload.signed) {
        this.signed = true;
      } else {
        this.$alert("签章失败，" + event.payload.error, "提示", {
          confirmButtonText: "确定",
          type: "error",
          callback: () => {
            this.visible = false;
          }
        });
      }
    };
  }

  saveFileToRemote() {
    const upload_url = new URL(this.upload_url);
    upload_url.searchParams.append(this.options.jwtKey, this.options.token);
    this.loading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "签章保存中..."
    });
    this.docViewerHelper.save(upload_url.toString());
  }

  show(
    options: App.Ntko.NtkoPdfH5SignOptions = {
      fileUrl: "",
      fileName: "",
      token: "",
      jwtKey: ""
    }
  ) {
    if (!options.fileName || !options.fileUrl || !options.jwtKey || !options.token) {
      this.$alert("参数错误，必须传入[fileUrl]、[fileName]、[jwtKey]、[token]参数", "提示", {
        confirmButtonText: "确定",
        type: "error"
      });
      return;
    }
    this.options.account = options.account || "";
    this.options.password = options.password || "";
    this.options.fileUrl = options.fileUrl || "";
    this.options.fileName = options.fileName || "";
    this.options.jwtKey = options.jwtKey || "";
    this.options.token = options.token || "";

    if (options.uploadUrl) {
      this.options.uploadUrl = options.uploadUrl;
    }

    this.visible = true;
  }

  async close() {
    // TODO 判断是否有未保存的签章，有的话提示保存
    // TODO 没有的话 直接关闭
    if (!this.signed) {
      this.visible = false;
    } else {
      let confirm;
      try {
        confirm = await this.$confirm("有新签章尚未保存，确定要关闭？", "提示", {
          type: "warning"
        });
      } catch (error) {
        confirm = false;
      }
      if (!confirm) return;
      this.visible = false;
    }
  }
}
